import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../lib/utils";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { ResponsiveDrawerForm } from "./ResponsiveDrawerForm";
import { AvatarImage } from "@radix-ui/react-avatar";
import { Edit } from "lucide-react";
import { Slider } from "./ui/slider";

const ProfileUpload = ({ path, pathData, setFieldValue, keyName, popupType = "" }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [showCropModal, setShowCropModal] = useState(true);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const [rotation, setRotation] = useState(0);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageName(file?.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    } else {
      setImageSrc(null);
      setShowCropModal(false);
    }
  };

  const handleCrop = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation,
        imageName
      );

      setCroppedImage(croppedImage?.fileUrl);
      toggleShowCropModal();
      if (setFieldValue && keyName) {
        setFieldValue(keyName, croppedImage?.fileData);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageSrc, croppedAreaPixels, rotation]);

  const toggleShowCropModal = () => {
    setShowCropModal(!showCropModal);
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="h-32 w-32 bg-background p-4 border rounded-lg overflow-hidden relative flex items-center justify-center z-0">
        {croppedImage || path ? (
          <>
            <Avatar className="h-full w-full">
              <AvatarImage src={croppedImage ? croppedImage : path} />
              <AvatarFallback>
                {pathData ? pathData : "Add Picture"}
              </AvatarFallback>
            </Avatar>
            <Input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="absolute w-full h-full opacity-0 cursor-pointer p-1"
            />
          </>
        ) : (
          <>
            <Avatar className="h-full w-full">
              <AvatarFallback>
                {pathData ? pathData : "Add Picture"}
              </AvatarFallback>
            </Avatar>
            <Input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="absolute w-full h-full opacity-0 cursor-pointer p-1"
            />
          </>
        )}
        {imageSrc && (
          <div className="absolute top-0 right-0">
            <ResponsiveDrawerForm
              description={""}
              title={"Crop Image"}
              handleOpen={() => {}}
              handleClose={() => {}}
              buttonText={<Edit />}
              className={"sm:max-w-1/2"}
              buttonClassName={"h-8 max-w-8 rounded-lg p-[5px]"}
              setOpen={setShowCropModal}
              open={showCropModal}
              write={true}
              popupType={popupType}
            >
              <div className="relative h-60 w-full overflow-hidden">
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  rotation={rotation}
                  aspect={1 / 1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onRotationChange={setRotation}
                  onCropComplete={onCropComplete}
                  style={
                    {
                      // mediaStyle: {
                      //   width: "100%",
                      //   height: "100%",
                      // },
                    }
                  }
                />
              </div>
              <div className="flex flex-col gap-4 px-2 py-4">
                <div>
                  <label className="text-sm font-medium mb-1 block">Zoom</label>
                  <Slider
                    min={1}
                    max={3}
                    step={0.1}
                    value={[zoom]}
                    onValueChange={(value) => setZoom(value[0])}
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="text-sm font-medium mb-1 block">
                    Rotation
                  </label>
                  <Slider
                    min={0}
                    max={360}
                    step={1}
                    value={[rotation]}
                    onValueChange={(value) => setRotation(value[0])}
                    className="w-full"
                  />
                </div>
              </div>
              <div className="flex justify-center gap-4">
                <Button onClick={handleCrop}>Crop</Button>
              </div>
            </ResponsiveDrawerForm>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileUpload;
